import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import VideoLabel from '@material-ui/icons/VideoLabel';
import { ClassAttributes, createElement } from 'react';

import theme from '../../../theme';
import { SPACING_UNIT } from '../../constant/spacing';
import { flexibleLayoutContainer } from '../../styleUtility/flexibleLayout';

export interface Props {
  count: number;
  max?: number;
  className?: string;
}

const UploadedItemCount = ({ count, max = 1, className }: ClassAttributes<HTMLElement> & Props) => {
  const num = count > max ? max : count;

  return (
    <Root className={className}>
      <MovieIcon />
      <Count noWrap>
        {num} / {max}
      </Count>
    </Root>
  );
};

const Root = styled('div')(
  flexibleLayoutContainer({
    direction: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
  }),
);

const MovieIcon = styled(VideoLabel)({
  marginRight: SPACING_UNIT,
  width: 24,
  height: 24,
  color: theme.palette.grey[600],
});

const Count = styled(Typography)({
  fontSize: 14,
  color: theme.palette.grey[600],
});

export default UploadedItemCount;
